import React, { CSSProperties, FC, useState } from 'react';
import styles from './project-logo.module.sass';
import localFallbackLogo from './yo.png';


type PropTypes = React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> &
    {
        src: string;
        alt?: string;
        height?: number;
        className?: string;
    }

export const ProjectLogo: FC<PropTypes> = (props) => {

    const [imgSrc, setImgSrc] = useState(props.src);
    const [error, setError] = useState(false);

    const handleImageError = () => {
        if (!error) {
            setImgSrc(localFallbackLogo);
            setError(true);
            console.log(`Remote image failed to load: ${props.src}. Using fallback.`);
        }
    };

    const style: CSSProperties = {};

    if (props.height)
        style.height = `${props.height}px`;

    return <img style={style}
                className={`${styles.projectLogo} ${props.className ?? ''}`}
                src={imgSrc}
                alt={props.alt}
                onError={handleImageError}
    />;
};

